import React from "react";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useIsPackageVersionOnActionEnabled() {
    return useOctopusFeatureToggle("package-version-on-action", false);
}
export function PackageVersionOnActionVisibility({ children }: React.PropsWithChildren<unknown>) {
    const isEnabled = useIsPackageVersionOnActionEnabled();
    return isEnabled ? <>{children}</> : null;
}
